// =========================================================
// Vojjin Errors Wrapper
// =========================================================
import {registerGlobal} from "./core.js";

class Errors {
    constructor() {
        window.onerror = (m, s, l, c, e) => {
            rock.logger.error("JS Error", {m, s, l, c, stack: e?.stack});
        };

        window.addEventListener("unhandledrejection", e => {
            rock.logger.error("Promise rejection", e.reason);
        });
    }
}

registerGlobal("Errors", Errors);
